import { render, staticRenderFns } from "./formpage.vue?vue&type=template&id=706a0598&scoped=true&"
import script from "./formpage.vue?vue&type=script&lang=js&"
export * from "./formpage.vue?vue&type=script&lang=js&"
import style0 from "./formpage.vue?vue&type=style&index=0&id=706a0598&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706a0598",
  null
  
)

export default component.exports